import React from 'react';
import { ifEnter } from '../../util';

interface Props {
  onClick: () => void;
  label: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  tabIndex?: number;
}

export const DivButton: React.FC<Props> = ({ children, onClick, className, tabIndex = 0, style, disabled, label = 'Button' }) => {
  const handleClick = disabled ? () => undefined : onClick;
  return (
    <div
      tabIndex={tabIndex}
      role="button"
      aria-label={label}
      className={className}
      onClick={handleClick}
      style={{ cursor: disabled ? 'default' : 'pointer', ...style }}
      onKeyDown={(event) => ifEnter(event, handleClick)}
    >
      {children}
    </div>
  );
};

export default DivButton;
